import { render, staticRenderFns } from "./TheLogoPanel.vue?vue&type=template&id=1042cc10&scoped=true&"
var script = {}
import style0 from "./TheLogoPanel.vue?vue&type=style&index=0&id=1042cc10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1042cc10",
  null
  
)

export default component.exports